<template>
  <div class='bg-abstract block-fullscreen' :class="{ 'is-mobile': mobile }">
    <div class='header-logo' id='headerLogo'>
      <icon name='td-logo' color='#393f49' />
    </div>
    <section class='block-fullscreen-center result-page'>
      <div id='fullpage'>
        <!-- Overall -->
        <section class='section'>
          <div class='result-percentage result-big bg-abstract-float'>
            <h1 class='title-main'>{{ resultText.overall.title }}</h1>
            <div class='number-float'>{{ initResults.overall }}%</div>
          </div>
          <a :href='`#${slidesNames[1]}`' class='nav-arrow-down'>
            <div class='title hidden-xs hidden-sm'>
              Role para baixo
            </div>
            <icon name='arrow-line-right' class='arrow-right animation-blink' />
          </a>
        </section>
        <!-- Geral -->
        <section class='section'>
          <div class='result-bar'>
            <div class='description' v-html='resultText.overall.text'></div>
            <div class="categories-bars">
              <div class='category-bar'>
                <div class='category'>CULTURA E LIDERANÇA</div>
                <div class='progress'>
                  <div class='fill' :style='widthPercentage(initResults.cultura_e_lideranca)'></div>
                </div>
                <div class='number-percentage'>{{ initResults.cultura_e_lideranca }}%</div>
              </div>              
              <div class='category-bar'>
                <div class='category'>AGILIDADE OPERACIONAL</div>
                <div class='progress'>
                  <div class='fill' :style='widthPercentage(initResults.agilidade_operacional)'></div>
                </div>
                <div class='number-percentage'>{{ initResults.agilidade_operacional }}%</div>
              </div>
              <div class='category-bar'>
                <div class='category'>TECNOLOGIA DIGITAL</div>
                <div class='progress'>
                  <div class='fill' :style='widthPercentage(initResults.tecnologia_digital)'></div>
                </div>
                <div class='number-percentage'>{{ initResults.tecnologia_digital }}%</div>
              </div>
              <div class='category-bar'>
                <div class='category'>EXPERIÊNCIA DO CLIENTE</div>
                <div class='progress'>
                  <div class='fill' :style='widthPercentage(initResults.experiencia_do_cliente)'></div>
                </div>
                <div class='number-percentage'>{{ initResults.experiencia_do_cliente }}%</div>
              </div>
              <div class='category-bar'>
                <div class='category'>EMPREENDEDORISMO DIGITAL</div>
                <div class='progress'>
                  <div class='fill' :style='widthPercentage(initResults.empreendedorismo_digital)'></div>
                </div>
                <div class='number-percentage'>{{ initResults.empreendedorismo_digital }}%</div>
              </div>
            </div>
          </div>
          <a :href='`#${slidesNames[2]}`' class='nav-arrow-down hidden-xs'>
            <icon name="arrow-small-down" class="animation-blink" />
          </a>
        </section>
        <!-- Category 1 -->
        <section class='section result-categories'>
          <div class='result-category'>
            <div class='category'>CULTURA E LIDERANÇA</div>
            <div class='result-percentage'>
              <h2 class='title-main'>{{ resultText.cultura_e_lideranca.title }}</h2>
              <div class='number-float' id='resultcultura_e_lideranca'>{{ initResults.cultura_e_lideranca }}%</div>
            </div>
            <div class='result-description' v-html='resultText.cultura_e_lideranca.text'></div>
          </div>
          <div class='result-category'>
            <div class='category'>AGILIDADE OPERACIONAL</div>
            <div class='result-percentage'>
              <h2 class='title-main'>{{ resultText.agilidade_operacional.title }}</h2>
              <div class='number-float' id='resultcultura_e_lideranca'>{{ initResults.agilidade_operacional }}%</div>
            </div>
            <div class='result-description' v-html='resultText.agilidade_operacional.text'></div>
          </div>
          
          <a :href='`#${slidesNames[3]}`' class='nav-arrow-down hidden-xs'>
            <icon name="arrow-small-down" class="animation-blink" />
          </a>
        </section>
        <!-- Category 2 -->
        <section class='section result-categories'>
          <div class='result-category'>
            <div class='category'>TECNOLOGIA DIGITAL</div>
            <div class='result-percentage'>
              <h2 class='title-main'>{{ resultText.tecnologia_digital.title }}</h2>
              <div class='number-float' id='resulttecnologia_digital'>{{ initResults.tecnologia_digital }}%</div>
            </div>
            <div class='result-description' v-html='resultText.tecnologia_digital.text'></div>
          </div>          
          <div class='result-category'>
            <div class='category'>EXPERIÊNCIA DO CLIENTE</div>
            <div class='result-percentage'>
              <h2 class='title-main'>{{ resultText.experiencia_do_cliente.title }}</h2>
              <div class='number-float' id='resulttecnologia_digital'>{{ initResults.experiencia_do_cliente }}%</div>
            </div>
            <div class='result-description' v-html='resultText.experiencia_do_cliente.text'></div>
          </div>
          <a :href='`#${slidesNames[4]}`' class='nav-arrow-down hidden-xs'>
            <icon name="arrow-small-down" class="animation-blink" />
          </a>
        </section>
        <!-- Category 3 -->
        <section class='section result-categories'>
          <div class='result-category center'>
            <div class='category'>EMPREENDEDORISMO DIGITAL</div>
            <div class='result-percentage'>
              <h2 class='title-main'>{{ resultText.empreendedorismo_digital.title }}</h2>
              <div class='number-float' id='resultempreendedorismo_digital'>{{ initResults.empreendedorismo_digital }}%</div>
            </div>
            <div class='result-description' v-html='resultText.empreendedorismo_digital.text'></div>
          </div>
          <!-- <a :href='`#${slidesNames[5]}`' class='nav-arrow-down hidden-xs'>
            <icon name="arrow-small-down" class="animation-blink" />
          </a> -->
        </section>
        <!-- Share -->
        <!-- <section class='section'>
          <div class="result-share">
            <h1 class='title'>Compartilhe seu resultado</h1>
            <div class="networks-social">
              <a href="#" @click.prevent="shareFaceBook">Facebook</a>
              <a :href="shareTwitterUrl" target="_blank">Twitter</a>
              <a :href="shareLinkedinUrl" target="_blank">Linkedin</a>
            </div>
          </div>
          <div class="footer-link">
            <a href="https://transformacaodigital.com/contato" target="_blank">Contate-nos</a>
          </div>
        </section> -->
      </div>
    </section>
  </div>
</template>

<script>
import Mobile from 'mobile-detect'
import { TweenMax } from 'gsap'
import Icon from '../Icon'
import fullpage from '../../../static/js/javascript.fullPage.min'
import Abstract from '../../assets/img/bg-abstract.jpg'
import AbstractFloat from '../../assets/img/abstract-float.png'


var isMobile = false;

if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
|| /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
   isMobile = true;
};

/* eslint-disable max-len */
export default {
  name: 'result',
  components: { Icon },
  data() {
    return {
      //slidesNames: ['final', 'geral', 'categoria1', 'categoria2', 'categoria3', 'compartilhe'],
      slidesNames: ['final', 'geral', 'categoria1', 'categoria2', 'categoria3'],
      nextScreen: '/result',
      initResults: {
        cultura_e_lideranca: 0,
        agilidade_operacional: 0,
        tecnologia_digital: 0,
        experiencia_do_cliente: 0,
        empreendedorismo_digital: 0,
        overall: 0,
      },
      test_results: {
        ...this.$store.state.test_results,
      },
      resultText: {
        overall: { text: '', title: '' },
        cultura_e_lideranca: { text: '', title: '' },
        tecnologia_digital: { text: '', title: '' },
        agilidade_operacional: { text: '', title: '' },
        experiencia_do_cliente: { text: '', title: '' },
        empreendedorismo_digital: { text: '', title: '' },
      },
      dataResultText: {
        overall: [
          { maxScore: 20, title: 'Você está no começo da jornada', text: '<p>Percebemos que você tem um longo caminho a percorrer rumo à maturidade digital. Mas não encare isso com desânimo, veja como uma grande oportunidade para o seu desenvolvimento pessoal e profissional. Para a transformação digital acontecer é necessário que as pessoas estejam dispostas a se capacitar e a evoluir em suas áreas de atuação.</p><p>Entender bem os conceitos ao redor da transformação digital é a prioridade para você nesse momento. Está pronto para começar?</p>' },
          { maxScore: 40, title: 'Você já deu alguns passos, agora é perseverar!', text: '<p>Alguns pontos do contexto da transformação digital já não são novidade para você. Porém é preciso compreendê-los com maior profundidade, além de expandir sua área de conhecimento. Alcançar a maturidade digital exige muitas vezes pensar diferente do modo que estamos habituados ou buscar alternativas para processos que podem ser otimizados.</p><p>Avalie as dimensões em que você obteve desempenho inferior e busque aprofundar-se nos temas que ainda desconhece.</p>' },
          { maxScore: 60, title: 'O digital é uma meta tangível para você', text: '<p>Pensar no contexto digital já é mais tangível para você. Isso te coloca à frente de muita gente no mercado. Entretanto, ainda temos um bom percurso a percorrer. Tenha como objetivo dominar as dimensões da transformação digital que destacamos, analisando desde cultura digital, até aspectos técnicos da tecnologia e agilidade operacional, sem deixar de lado o empreendedorismo e a experiência do cliente.</p><p>Mesmo que sua função hoje não exija conhecimento aprofundado em todos esses tópicos, vale lembrar que eles são essenciais para alcançar a maturidade digital. Mantenha o foco e sucesso na jornada!</p>' },
          { maxScore: 70, title: 'Você alcançou nível satisfatório de maturidade digital', text: '<p>Percebemos que você já possui conhecimento e tem executa práticas do contexto da transformação digital que dão mais eficiência ao seu dia a dia. Agora o foco é evoluir alguns pontos para levar você ao estágio de excelência.</p><p>A dica para você é: "ouse mais dentro do digital!". Explore seu mindset digital para sustentar as mudanças que a transformação digital agrega em pessoas, processos e ferramentas. Pesquise novas alternativas e compartilhe com outros profissionais as experiências possíveis de implementação no seu cenário atual. Continue, falta pouco!</p>' },
          { maxScore: 80, title: 'Sorria, você alcançou nível satisfatório de maturidade digital', text: '<p>Percebemos que você já possui conhecimento e tem executa práticas do contexto da transformação digital que dão mais eficiência ao seu dia a dia. Agora o foco é evoluir alguns pontos para levar você ao estágio de excelência.</p><p>A dica para você é: "ouse mais dentro do digital!". Explore seu mindset digital para sustentar as mudanças que a transformação digital agrega em pessoas, processos e ferramentas. Pesquise novas alternativas e compartilhe com outros profissionais as experiências possíveis de implementação no seu cenário atual. Continue, falta pouco!</p>' },
          { maxScore: 100, title: 'Parabéns! Você alcançou um alto nível de maturidade digital', text: '<p>O contexto da transformação digital já faz parte da sua expertise e isso coloca você como um profissional apto a desbravar novos desafios nesse cenário de mudanças. Aliás, ser um agente de mudanças é uma habilidade fundamental no cenário corporativo da nova economia.</p><p>Mantenha o foco na evolução e no aprendizado contínuo sobre transformação digital. Como você sabe, mesmo quem está à frente não pode parar. Avalie ainda pontos que você ter maior efetividade e vamos em frente!</p>' },
        ],
        cultura_e_lideranca: [
          { maxScore: 20, title: 'Desenvolva seu mindset digital', text: '<p>Uma cultura fortalecida no contexto digital é fundamental para que a transformação aconteça. É imprescindível uma mudança na forma como se pensa a relação com as pessoas, as ferramentas e os processos da empresa para alcançar bons resultados na transformação digital. Foque em crescer nesses aspectos!</p><p>Além disso, tenha em vista que assumir a liderança da disrupção pode fazer de você um profissional de destaque no mercado.</p>' },
          { maxScore: 40, title: 'A transformação passa pela sua cultura', text: '<p>Transformação digital não quer dizer apenas sobre tecnologia, as pessoas são essenciais para o êxito de uma empresa nesse novo cenário. E quando falamos em pessoas incluímos a forma como elas interagem com esse novo contexto de disrupção.</p><p>Invista no desenvolvimento de um novo mindset, aberto às possibilidades de mudança que a transformação digital oferece.</p>' },
          { maxScore: 60, title: 'Já sabe a importância de pensar diferente', text: '<p>A forma como você se posiciona diante de alguns desafios da transformação digital sinalizam sua abertura ao pensamento disruptivo. Porém, para chegar a ser um verdadeiro líder nesse contexto é necessário assumir mais riscos e quebrar outros paradigmas.</p><p>Você está no caminho! Agora é buscar se desenvolver para encontrar um ambiente disponível e propício às mudanças que os próximos anos esperam.</p>' },
          { maxScore: 80, title: 'Agora desbrave novos mares', text: '<p>Você tem características que te posicionam mais à dianteira quando falamos na forma de pensar a transformação digital. Aproveite sua abertura ao pensamento disruptivo para consolidar o mindset digital e desenvolver habilidades fundamentais a um líder do contexto digital.</p><p>Participe mais de conversas com pessoas que possuem um mindset digital amadurecido. Lembre-se que o compartilhamento de ideias fortalece nossa cultura.</p>' },
          { maxScore: 100, title: 'Muito bem, agora é só fazer acontecer', text: '<p>Acreditamos que o primeiro passo para uma verdadeira transformação digital parte da forma como as pessoas pensam e atuam nesse novo cenário. E você demonstrou estar preparado para se aventurar nas novas possibilidades que o mundo digital reserva.</p><p>Continue desenvolvendo-se, compartilhe conhecimento e ajude aqueles que estão próximos de você a também se abrirem a um mindset digital.</p>' },
        ],
        agilidade_operacional: [
          { maxScore: 20, title: 'Cuidado com a improdutividade', text: '<p>Você ainda está condicionado a processos analógicos, o que no cenário de transformação digital pode significar um atraso para a evolução. Ao longo da história vimos os processos serem substituídos por modelos mais efetivos, agora estamos em mais um momento desses.</p><p>É hora de investir no conhecimento de metodologias ágeis e novos modelos de resolução de problemas que incluem soluções digitais.</p>' },
          { maxScore: 40, title: 'Go ahead, my friend!', text: '<p>Você já percebeu que alguns processos podem ser feitos de maneira diferente. Esse é o primeiro passo! Agora é preciso investir mais tempo e esforço na busca por novas formas de executar as tarefas do seu dia a dia.</p><p>Ter mais agilidade operacional no contexto digital não é opcional. Infelizmente, você pode ficar para trás caso não queira acelerar.</p>' },
          { maxScore: 60, title: 'Eu não vim até aqui pra desistir agora...', text: '<p>Você está praticamente no meio do caminho: já entendeu que é possível ter mais efetividade nos processos, mas ainda precisa ganhar mais experiência na aplicação de metodologias ágeis.</p><p>Busque compreender melhor como as ferramentas podem auxiliar nos processos de desenvolvimento de projetos e explore novas possibilidades no seu contexto de trabalho.</p>' },
          { maxScore: 80, title: 'Estamos num bom ritmo', text: '<p>Processos colaborativos, automação de tarefas e modelos disruptivos para resolução de problemas já não são monstros para você. E isso é muito bom!</p><p>A ideia agora é evoluir. Busque mais conhecimento sobre esses tópicos e teste possibilidades desde a execução de tarefas simples a grandes projetos.</p>' },
          { maxScore: 100, title: 'Agilidade e eficiência são seu sobrenome', text: '<p>É ótimo saber que você compreende a aplicação prática das metodologias ágeis e a importância de desenhar/executar processos buscando maior efetividade com ajuda de soluções digitais.</p><p>Colaborar com a construção de ambientes colaborativos, mantendo-os ativos e com pessoas engajadas é o caminho para estar sempre em evolução.</p>' },
        ],
        tecnologia_digital: [
          { maxScore: 20, title: 'Ela veio para ajudar', text: '<p>A evolução tecnológica gera benefícios para as pessoas, negócios, sociedade... enfim, é um caminho sem volta. Não espere mais um dia para começar a conhecer mais sobre esse pilar da transformação digital.</p><p>Temas como análise de dados, automação, mobilidade, atendimento digital já estão mais comuns no cotidiano das pessoas e são um bom ponto de partida nessa jornada de conhecimento. Siga em frente!</p>' },
          { maxScore: 40, title: 'Ela veio pra ficar!', text: '<p>Você já notou que a tecnologia digital veio pra ficar e transformar o cotidiano das pessoas. Agora é dedicar-se a entender um pouco mais sobre como a aplicação dessas tecnologias vão gerar benefícios no nosso dia a dia.</p><p>Além disso, implantar estratégias com base em análise de dados e utilizar tecnologias/ferramentas adequadas podem garantir a existência do seu negócio nos próximos anos.</p>' },
          { maxScore: 60, title: 'Algumas coisas estão claras, outras nem tanto', text: '<p>Que tal elucidar de vez as dúvidas sobre os conceitos de tecnologia que fazem parte da transformação digital? Essa deve ser sua meta para aumentar seu nível de maturidade digital.</p><p>Boa parte das tecnologias que citamos no diagnóstico você provavelmente já ouviu falar, agora é entender como elas podem ser aplicadas no cotidiano do seu trabalho para gerar mais resultados.</p>' },
          { maxScore: 80, title: 'Isso é sobre resultados', text: '<p>E os resultados podem ser: mais agilidade, melhor experiência, mais lucratividade, e muitas coisas boas quando aplicamos a tecnologia ideal no nosso cenário corporativo. Identificar a necessidade de usar tecnologias/ferramentas já é tangível para você, mas saber como elas trarão resultados efetivos está entre os pontos a evoluir.</p><p>Falta pouco para você conseguir resultados ainda mais extraordinários. Que tal fazer um review de estudos sobre os principais conceitos que fazem parte da transformação digital com foco em aplicação e geração de resultados?</p>' },
          { maxScore: 100, title: 'Gostamos de ver', text: '<p>Você conhece os principais tópicos que fazem parte do pilar tecnologia quando falamos em transformação digital. O impacto do uso de dados para tomada de decisões, a aplicação estratégica de ferramentas para otimização de resultados e os benefícios das tecnologias emergentes já são pauta frequente no seu dia a dia.</p><p>Apenas lembre-se que a respeito de tecnologia não podemos ficar parados. Continue estudando, aplicando, testando e se desenvolvendo. O futuro é logo ali!</p>' },
        ],
        experiencia_do_cliente: [
          { maxScore: 20, title: '"Experiência do cliente" não é modismo', text: '<p>"Experiência do cliente" é necessidade. E isso deveria estar entre as pautas principais de toda empresa, já que entender sua força no atual cenário digital é o caminho para se manter relevante e não naufragar.</p><p>Comece entendendo melhor os hábitos e as expectativas dos consumidores. Invista em conhecer também sobre jornada de compra e como criar uma melhor experiência em cada estágio.</p>' },
          { maxScore: 40, title: 'Aprenda mais com seu cliente', text: '<p>Engana-se quem pensa que é possível criar uma boa experiência sem falar com clientes. O seu produto/serviço existe para suprir uma necessidade do seu cliente, se você não o conhece (de verdade), como poderá ajudá-lo?</p><p>Experiência tem a ver com comportamento, impacto, resolver problemas, facilidades, expectativas. Invista tempo e recursos para entender melhor seu cliente e melhore seu produto/serviço agregando mais valor.</p>' },
          { maxScore: 60, title: 'Só falta investir um pouco mais em experiência', text: '<p>Você já sabe quem é o seu cliente e o que ele precisa quando busca o seu produto/serviço. Agora é hora de valorizar mais a experiência que ele tem durante toda a jornada de compra.</p><p>Revise os estágios da jornada de compra e o processo de pós-vendas identificando formas de melhorar a experiência do seu cliente. Lembre-se que ele deve se sentir seguro e satisfeito por ter escolhido fazer negócio com a sua empresa.</p>' },
          { maxScore: 80, title: 'Explore novas possibilidades', text: '<p>"Experiência do cliente" já faz parte do seu vocabulário e você já entendeu a importância desse fator na estratégia do seu produto/serviço.</p><p>O caminho agora é explorar formas de surpreender o seu cliente, testar possibilidades e/ou encontrar novas maneiras de agregar valor (lembrando que valor é diferente de preço) ao seu produto/serviço.</p>' },
          { maxScore: 100, title: 'Seus clientes devem ser seus fãs', text: '<p>Parabéns. Você cuida e valoriza o seu cliente! Esse é o sentimento que ele tem quando você explora maneiras de gerar uma ótima experiência.</p><p>Invista continuamente em experiências únicas para seus clientes e que ajudem seu produto/serviço a subir degraus na liderança do seu nicho de mercado. Traduzir as expectativas do seu cliente em entregas potencializadas pelo digital é o caminho que  pode te levar além.</p>' },
        ],
        empreendedorismo_digital: [
          { maxScore: 20, title: 'Todos podem ser empreendedores', text: '<p>Empreender não significa apenas criar novos negócios, podemos também empreender dentro dos nossos setores de trabalho.</p><p>O importante é ter um "espírito empreender", um desejo constante de encontrar novas possibilidades, de resolver problemas, de sermos produtivos. Esse é o nosso convite para você a partir de agora!</p>' },
          { maxScore: 40, title: 'Não precisa ter medo', text: '<p>Às vezes quando falamos em disrupção, crescimento de negócios, networking parece algo distante (ou difícil), porém são conceitos que podem ser aplicados apenas com um pouco de dedicação no nosso dia a dia.</p><p>Aproveita que você já tem noção de alguns aspectos do empreendedorismo digital e perca o receio de investir tempo para se aprofundar nesses conceitos. Empreender faz a diferença não só em negócios do futuro, mas no seu trabalho hoje.</p>' },
          { maxScore: 60, title: 'Está ficando legal', text: '<p>Produtividade, disrupção e crescimento já são termos familiares para você. Mas para ficar melhor, vale a pena descobrir agora como trazer mais crescimento com um pensamento disruptivo na solução dos problemas da sua empresa ou de seus clientes.</p><p>Desafie-se a descobrir novas formas de superar obstáculos, de ser mais produtivo e/ou de traçar metas tangíveis e mensuráveis para concluir projetos estagnados.</p>' },
          { maxScore: 80, title: 'Um leque de oportunidades', text: '<p>É assim que a vida é para verdadeiros empreendedores, a cada novo desafio eles enxergam um leque de oportunidades. Percebemos que você tem grande potencial para chegar nesse nível.</p><p>Aproveite para analisar os projetos/trabalhos que você participa/executa atualmente e tente idealizar novas soluções para problemas corriqueiros. Expandir o networking, saber o que acontece no seu mercado de atuação e desenvolver o mindset digital são pontos que nunca podem sair de vista.</p>' },
          { maxScore: 100, title: 'Pronto para fazer a diferença', text: '<p>Você possui as habilidades necessárias para trabalhar em alta performance e gerar resultados efetivos em novos negócios e/ou em projetos que já estejam em execução.</p><p>Continue nesse caminho de disrupção, com um mindset digital, focado em produtividade e resultados efetivos, sem perder a criatividade que deve fazer parte de todo empreendedor. Ajude também seus colegas de trabalho a evoluírem e fortaleça seu networking local.</p>' },
        ],
      },
      faceBook: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    window.$loadImages([Abstract, AbstractFloat]).then(() =>
      next()
    )
  },
  mounted() {
    /* eslint-disable */
    window.fbAsyncInit = () => {
      FB.init({
        appId      : '398443737018854',
        xfbml      : true,
        version    : 'v2.12'
      });
      FB.AppEvents.logPageView();
      this.faceBook = FB;
    }

    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/pt_BR/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
    /* eslint-enable */

    this.processResultText()
    const logo = document.getElementById('headerLogo')

    isMobile && this.animateNumbers([
      'overall',
      'cultura_e_lideranca',
      'tecnologia_digital',
      'agilidade_operacional',
      'experiencia_do_cliente',
      'empreendedorismo_digital'
    ], false)

    !isMobile && fullpage.initialize('#fullpage', {
      anchors: this.slidesNames,
      navigation: false,
      scrollBar: true,
      afterLoad: (anchor) => {
        switch (anchor) {
          case this.slidesNames[0]:
            this.animateNumbers(['overall'])
            break
          case this.slidesNames[1]:
            this.animateNumbers([
              'cultura_e_lideranca',
              'tecnologia_digital',
              'agilidade_operacional',
              'experiencia_do_cliente',
              'empreendedorismo_digital'
            ], false)
            break
          case this.slidesNames[2]:
            this.animateNumbers([
              'cultura_e_lideranca',
              'agilidade_operacional'
            ])
            break
          case this.slidesNames[3]:
            this.animateNumbers([
              'tecnologia_digital',
              'experiencia_do_cliente'
            ])
            break
          case this.slidesNames[4]:
            this.animateNumbers([
              'empreendedorismo_digital'
            ])
            break
        }
      },
      onLeave: (index, nextIndex) => {
        if (nextIndex === this.slidesNames.length) {
          logo.style.animationName = 'fade-to-bottom'
        } else
          logo.style.animationName = 'fade-to-bottom-reverse'
      }
    })
  },
  computed: {
    mobile() {
      return !!new Mobile(window.navigator.userAgent).phone()
    },
    shareLinkedinUrl() {
      const url = encodeURI('https://score.transformacaodigital.com/');
      const text = encodeURI(`Meu resultado foi ${this.initResults.overall}% - "${this.resultText.overall.title}". Descubra o seu: ${url}`);
      return `https://www.linkedin.com/shareArticle?url=${url}&summary=${text}`
    },
    shareTwitterUrl() {
      const text = encodeURI(`Meu resultado foi ${this.initResults.overall}% - "${this.resultText.overall.title}". Descubra o seu:`);
      const url = encodeURI('https://score.transformacaodigital.com/');
      const hashtags = encodeURI('TransformaçãoDigital,MaturidadeDigital,TDScore');
      return `https://twitter.com/share?url=${url}&hashtags=${hashtags}&text=${text}`
    }
  },
  methods: {
    shareFaceBook() {
      /* eslint-disable */
      console.log('-- faceBook');
      console.log(this.faceBook);
      console.log('-- FB');
      console.log(FB);
      FB.ui({
        method: 'share',
        href: 'http://tdscore.herokuapp.com/',
        hashtag: '#tdscore',
        quote: 'Teste quote'
      }, (response) => {
        console.log(response);
      });
      /* eslint-enable */
    },
    processResultText() {
      const keys = Object.keys(this.dataResultText);
      for (let i = 0; i < keys.length; i += 1) {
        this.scoreText(keys[i])
      }
    },
    scoreText(score) {
      const scoreField = this.test_results[`${score}`]
      for (let i = 0; i < this.dataResultText[score].length; i += 1) {
        const dataText = this.dataResultText[score][i]
        if (scoreField <= dataText.maxScore) {
          this.resultText[score] = {
            text: dataText.text,
            title: dataText.title
          }
          break
        }
      }
    },
    animateNumbers(fields, reset = true) {
      const optionFields = []
      for (let i = 0; i < fields.length; i += 1) {
        if (reset) this.initResults[fields[i]] = 0
        Object.assign(optionFields, { [fields[i]]: this.test_results[fields[i]] })
      }
      TweenMax.to(this.initResults, 1, {
        ...optionFields,
        onUpdate: () => {
          for (let i = 0; i < fields.length; i += 1) {
            this.initResults[fields[i]] = Math.ceil(this.initResults[fields[i]])
          }
        },
      });
    },
    widthPercentage(value) {
      return `width:${value}%`
    }
  }
};
</script>

<style lang="scss" scoped>
  
  .result-page {
    p {
      font-size: 16px;
    }

    .fullpage-wrapper {
      width: 100%;
      .section {
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
    }
    .result-bar {
      color: white;
      .description {
        padding: 0 25%;
        font-size: 20px;
        letter-spacing: 1px;
        padding-bottom: 40px;
        @media (max-width: 576px) {
          padding: 0 15px 42px;
        }
      }
      .categories-bars {
        display: flex;
        align-items: center;
        margin: 0 auto;
        flex-direction: column;
        width: 80%;
        @media (max-width: 576px) {
          width: 100%;
        }
      }
      .category-bar {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        text-transform: uppercase;
        letter-spacing: 2px;
        margin-bottom: 24px;
        .category {
          margin-top: 3px;
          text-align: right;
          width: 205px;
          @media (max-width: 576px) {
            text-align: left;
            margin-left: 15px;
            width: 85px;
          }
        }
        .progress {
          background-color: rgba(black, .2);
          flex: 1;
          margin: 0 16px;
          height: 16px;
          .fill {
            height: 100%;
            width: 0;
            background-color: rgba(white, .5);
            transition: width .5s;
            will-change: width;
          }
        }
        .number-percentage {
          border-radius: 2px;
          box-shadow: 0px 21px 25.23px 3.77px rgba(0, 0, 0, 0.1), 0px 0px 17px 0px rgba(0, 0, 0, 0.1);
          background-color: rgba(white,.1);
          padding: 2px 4px;
          border-color: #656D72;
          letter-spacing: 2px;
          text-indent: 2px;
          font-size: 18px;
          margin-right: 12%;
        }
      }
    }
    .result-percentage {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      .title-main {
        position: relative;
        z-index: 1;
        color: white;
        font-size: 20px;
        font-weight: normal;
        text-transform: uppercase;
        letter-spacing: 5px;
        @media (max-width: 576px) {
          margin: 0 15px;
        }
      }
      &.result-big {
        height: 100vh;
        width: 100vw;
        .title-main {
          padding: 0 100px;
          font-size: 42px;
          letter-spacing: 10px;
          @media (max-width: 700px) {
            padding: 0 15px;
          }
        }
        .number-float {
          font-size: 300px;
        }
      }
    }
    .number-float {
      font-family: 'PFDin';
      position: absolute;
      margin: 0 auto;
      font-size: 150px;
      color: rgba(white, .3);
      text-shadow: 0 0 20px rgba(white, .5);
      -webkit-mask-image: -webkit-gradient(linear, left top, left bottom, from(black), color-stop(85%, transparent));
      mask-image: linear-gradient(to bottom, black, transparent 85%);
    }
    .result-categories {
      @media (max-width: 576px) {
        flex-direction: column;
      }
    }
    .result-category {
      display: flex;
      flex-direction: column;
      text-align: center;
      color: white;
      width: 38%;

      flex: 1;
      max-width: 38%;

      &:first-child {
        align-self: flex-end;
        margin-bottom: 10px;
        margin-top: 0;
      }
      &.center {
        align-self: flex-end;
        margin-bottom: 10px;
        margin-top: 0;
      }
      @media (max-width: 576px) {
        width: 100%;
        margin: 110px 0 0 0 !important;
      }
      .category {
        font-size: 18px;
        text-transform: uppercase;
        letter-spacing: 15px;
        position: relative;
        margin: 0 auto 35px;
        @media (max-width: 576px) {
          letter-spacing: 8px;
          transform: translateX(8px);
        }
        &:before {
          content: "";
          position: absolute;
          top: -30%;
          left: -18px;
          right: 0;
          bottom: 0;
          padding: 0 10px;
          background-color: rgba(white, .102);
          height: 160%;
          width: 100%;
        }
        &:after {
          content: "";
          position: absolute;
          bottom: -45px;
          left: -15px;
          right: 0;
          margin: 0 auto;
          display: block;
          width: 1px;
          height: 20px;
          background-color: white;
        }
      }
      .result-percentage {
        height: 130px;
        @media (max-width: 576px) {
          height: 220px;
        }
      }
      .result-description {
        text-align: left;
        font-size: 14px;
        line-height: 26px;
        letter-spacing: 1px;
        padding: 0 25px;
        /deep/ > p:first-child {
          margin-top: 0;
        }
      }
    }
  }
  .result-share {
    text-align: center;
    .title {
      color: white;
      text-transform: uppercase;
      font-weight: normal;
      letter-spacing: 20px;
      position: relative;
      margin-bottom: 100px;
      @media (max-width: 576px) {
        margin-left: 20px;
        margin-top: 100px;
        margin-bottom: 60px;
        letter-spacing: 12px;
      }
      @media (min-width: 576px) and (max-width: 991px) {
        letter-spacing: 10px;
        margin-bottom: 80px;
      }
      &:after {
        content: "";
        position: absolute;
        bottom: -60px;
        left: -20px;
        right: 0;
        margin: 0 auto;
        display: block;
        width: 1px;
        height: 30px;
        background-color: white;
      }
    }
    .networks-social {
      display: flex;
      justify-content: center;
      @media (max-width: 576px) {
        flex-direction: column;
        padding: 24px 0;
      }
      @media (min-width: 576px) and (max-width: 991px) {
        flex-direction: column;
      }
      a {
        text-transform: uppercase;
        letter-spacing: 5px;
        text-indent: 5px;
        font-size: 16px;
        margin: 0 20px 0 0;
        background-color: rgba(black, .05);
        color: white;
        padding: 40px 70px;
        display: inline-block;
        text-decoration: none;
        transition: background .3s;
        &:hover {
          background: linear-gradient(to left, rgba(white, .2), transparent);
        }
        @media (max-width: 576px) {
          width: 100%;
          padding: 40px 0;
          margin: 10px 0;
        }
        @media (min-width: 576px) and (max-width: 991px) {
          margin: 12px 0;
        }
      }
    }
  }
  .footer-link {
    justify-content: center;
    @media (max-width: 576px) {
      position: relative;
      a {
        flex: 1;
        margin-top: 40px;
        padding: 40px 0;
        text-align: center;
      }
    }
  }
  .is-mobile {
    #fullpage {
      display: flex;
      flex-direction: column;
    }
    &.bg-abstract {
      background: none;
    }
  }
</style>

<style lang="scss">
  #headerLogo {
    animation-duration: 1s;
    animation-fill-mode: forwards;
  }
  @keyframes fade-to-bottom {
    49% {
      bottom: initial;
    }
    50% {
      opacity: 0;
      top: initial;
      bottom: 0;
    }
    100% {
      top: initial;
      bottom: 0;
    }
  }
  @keyframes fade-to-bottom-reverse {
    0% {
      top: initial;
      bottom: 0;
    }
    49% {
      bottom: 0;
    }
    50% {
      opacity: 0;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/test/Result.vue